import { useInfiniteQuery } from '@tanstack/react-query';

import SearchService, { type NearbyHotelOffersParams } from '~/services/SearchService';

export const nearbyHotelOffersQueryKeys = {
  all: ['search', 'nearby-hotel-offers'] as const,
  search: (params: NearbyHotelOffersParams) => [...nearbyHotelOffersQueryKeys.all, params] as const,
};

export function useGetNearbyHotelOffers(params?: NearbyHotelOffersParams) {
  return useInfiniteQuery({
    queryKey: params ? nearbyHotelOffersQueryKeys.search(params) : nearbyHotelOffersQueryKeys.all,
    queryFn: ({ signal, pageParam }) => {
      if (!params) {
        throw new Error('Nearby hotel search parameters are required.');
      }

      return SearchService.getNearbyHotelOffers(
        {
          ...params,
          cursor: pageParam ?? params.cursor,
        },
        { signal },
      );
    },
    enabled: !!params,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
    initialPageParam: undefined as string | undefined,
    retry: false,
  });
}
